import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

// Function to clean inline styles and unwanted HTML tags
const cleanHtmlContent = (html) => {
  // Remove inline styles
  const cleanedHtml = html.replace(/style="[^"]*"/g, "");
  return cleanedHtml;
};

const BlogSectionDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        const response = await axios.get(`https://agpipefitting.org.et/api/blogs/${id}`);
        if (response.data) {
          setBlog(response.data);
        } else {
          setError("Blog not found.");
        }
      } catch (err) {
        setError("Failed to load blog post.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogDetails();
  }, [id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-danger">
          <h5>{error}</h5>
        </div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div>
          <h5>Blog not found.</h5>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          {/* Clickable Blog Image */}
          <div className="mb-4 text-center">
            <a href={`https://agpipefitting.org.et/storage/${blog.image}`} target="_blank" rel="noopener noreferrer">
              <img
                src={`https://agpipefitting.org.et/storage/${blog.image}`}
                alt={blog.title}
                className="img-fluid rounded shadow-lg"
                style={{ maxWidth: "1400px", height: "500px", cursor: "pointer" }}
              />
            </a>
          </div>

          {/* Blog Title */}
          <div className="text-center">
            <h1 className="fw-bold text-primary mb-3" style={{ fontSize: "2.5rem" }}>
              {blog.title}
            </h1>
            <p className="text-muted mb-4" style={{ fontSize: "1rem" }}>
              Published on: {new Date(blog.created_at).toLocaleDateString()}
            </p>
          </div>

          {/* Blog Content */}
          <div
            className="p-4 rounded-3 shadow-sm"
            style={{
              backgroundColor: "#f9f9f9",
              lineHeight: "1.8",
              fontSize: "1.2rem",
              textAlign: "justify",
            }}
            dangerouslySetInnerHTML={{
              __html: cleanHtmlContent(blog.content),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BlogSectionDetails;
